import * as fromProfile from '~/store/reducers/profile';

export const getProfileIsSyncing = (state) => fromProfile.getProfileIsSyncing(state);
